import { Injectable } from '@angular/core';
import {
  HttpContext,
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Header canónico del contexto de tienda. Debe coincidir con `SiteContext.HEADER` del backend
 * (doc/epics/team-access/SITE_CONTEXT_PHASE.md).
 */
export const SITE_ID_HEADER = 'site-id';

/**
 * Tienda sobre la que opera UNA petición concreta.
 *
 * Va pegada a la petición, no se deduce de la ruta activa ni del último site elegido: una
 * petición puede terminar después de que el usuario haya cambiado de tienda, y el dashboard
 * global consulta varias a la vez. Los servicios de una tienda reciben `siteId` en su firma y lo
 * declaran con `withSiteContext`; los globales y de cuenta no lo usan.
 */
export const SITE_CONTEXT = new HttpContextToken<string | null>(() => null);

/** Contexto para una petición de UNA tienda. Añádelo en las opciones de `HttpClient`. */
export function withSiteContext(siteId: string, context: HttpContext = new HttpContext()): HttpContext {
  return context.set(SITE_CONTEXT, siteId);
}

/** Pone el header `site-id` a las peticiones que declaran su tienda, y solo a esas. */
@Injectable()
export class SiteContextInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const siteId = request.context.get(SITE_CONTEXT)?.trim();
    if (!siteId) {
      return next.handle(request);
    }
    return next.handle(request.clone({ setHeaders: { [SITE_ID_HEADER]: siteId } }));
  }
}
